import React from 'react'
import {Link} from 'react-router-dom'


export default class extends React.Component {

  render() {
    return (
      <div>

        <div className="full header">
          <div className="wrap">
            <h1>{this.props.config.app_id}</h1>
            {!this.props.session_token && <div><Link to="/" onClick={(e) => this.props.openModal(e)} className="cta">inloggen</Link></div>}
            {this.props.session_token && <div><Link to="/" className="cta">dashboard</Link></div>}
          </div>
        </div>

        <div className="full">
          <div className="wrap">
            <div className="content-text">
              <p>Lorem Ipsum is slechts een proeftekst uit het drukkerij- en zetterijwezen. Lorem Ipsum is de standaard proeftekst in deze bedrijfstak sinds de 16e eeuw, toen een onbekende drukker een zethaak met letters nam en ze door elkaar husselde om een font-catalogus te maken.</p>
            </div>
            <div className="content-text">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam sem odio, fringilla eu tortor eu, venenatis imperdiet ante. Aenean eros quam, dapibus quis velit at, faucibus consectetur urna. Integer vitae neque ante. Quisque leo lacus, molestie et ex nec, suscipit dignissim lectus. Fusce ultrices turpis maximus lorem auctor rutrum. Nulla placerat rutrum quam, in finibus neque. Nam tristique placerat elit et maximus. Aenean id velit odio. Praesent vulputate finibus quam sed rutrum. Suspendisse potenti. Quisque laoreet dolor vel ligula faucibus, id accumsan nisi lacinia. Aenean quam sapien, sollicitudin quis iaculis a, luctus convallis libero.</p>
            </div>
          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Start.js